import { render, staticRenderFns } from "./FormatCurrency.vue?vue&type=template&id=1a10129e&scoped=true&"
import script from "./FormatCurrency.vue?vue&type=script&lang=js&"
export * from "./FormatCurrency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a10129e",
  null
  
)

export default component.exports